import type { ImageDataLike } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';


interface IImageData {
  data: ImageDataLike;
  name: string;
}

function useFooterExtraImagesQuery(): IImageData[] | null {
  const data = useStaticQuery(graphql`
    query FooterExtraImages {
      allFile(filter: { sourceInstanceName: { eq: "images" }, relativeDirectory: { eq: "footer/extra" } }) {
        edges {
          node {
            name
            childImageSharp {
              gatsbyImageData(height: 50)
            }
          }
        }
      }
    }
  `);

  return data.allFile.edges.map(({ node }: { node: Queries.File }) => ({
    data: node.childImageSharp?.gatsbyImageData,
    name: node.name,
  }));
}

export default useFooterExtraImagesQuery;
